import { render, staticRenderFns } from "./Kriminalitas.vue?vue&type=template&id=63372cda&scoped=true"
import script from "./Kriminalitas.vue?vue&type=script&lang=js"
export * from "./Kriminalitas.vue?vue&type=script&lang=js"
import style0 from "./Kriminalitas.vue?vue&type=style&index=0&id=63372cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63372cda",
  null
  
)

export default component.exports